module.exports = __webpack_public_path__ + "static/media/star.875cb2fc.svg";